import { render } from "./HeaderSeoComponent.vue?vue&type=template&id=3ee5dda4"
import script from "./HeaderSeoComponent.vue?vue&type=script&lang=js"
export * from "./HeaderSeoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__